import { Product } from '@inter-ikea-storageone/range';

// Returns all inserts where KALLAX is included in the name, for the inserts subcategory
export const getInserts = (products: Product[]) => {
  return products.filter(p => p.name.includes('KALLAX'));
};

// Returns all inserts where KALLAX is NOT included in the name, for the boxes subcategory
export const getBoxes = (products: Product[]) => {
  return products.filter(p => !p.name.includes('KALLAX'));
};
